import { render } from "./ProcessSettingList.vue?vue&type=template&id=5ac1681a&scoped=true"
import script from "./ProcessSettingList.vue?vue&type=script&lang=js"
export * from "./ProcessSettingList.vue?vue&type=script&lang=js"

import "./ProcessSettingList.vue?vue&type=style&index=0&id=5ac1681a&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ac1681a"],['__file',"src/views/h5/common/plat/process/ProcessSettingList.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5ac1681a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5ac1681a', __exports__)) {
    api.reload('5ac1681a', __exports__)
  }
  
  module.hot.accept("./ProcessSettingList.vue?vue&type=template&id=5ac1681a&scoped=true", () => {
    api.rerender('5ac1681a', render)
  })

}


export default __exports__